import { render, staticRenderFns } from "./PrenatalConsentContainer.vue?vue&type=template&id=6fffed94&scoped=true"
import script from "./PrenatalConsentContainer.vue?vue&type=script&lang=js"
export * from "./PrenatalConsentContainer.vue?vue&type=script&lang=js"
import style0 from "./PrenatalConsentContainer.vue?vue&type=style&index=0&id=6fffed94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fffed94",
  null
  
)

export default component.exports